/**
 * Navigation data for the application
 * This serves as a single source of truth for all navigation items
 */

const insuranceProducts = [
  {
    label: 'Home Insurance',
    to: '/products/homeinsurance',
    type: 'router',
    iconName: 'mdi:home'
  },
  {
    label: 'Auto Insurance',
    to: '/products/autoinsurance',
    type: 'router',
    iconName: 'mdi:car'
  },
  {
    label: 'Flood Insurance',
    to: '/products/floodinsurance',
    type: 'router',
    iconName: 'mdi:water'
  },
  {
    label: 'Life Insurance',
    to: '/products/lifeinsurance',
    type: 'router',
    iconName: 'mdi:heart-pulse'
  },
  {
    label: 'Medicare',
    to: '/products/medicare',
    type: 'router',
    iconName: 'mdi:medical-bag'
  },
  {
    label: 'Business Insurance',
    to: '/products/businessinsurance',
    type: 'router',
    iconName: 'mdi:office-building'
  },
  {
    label: 'Umbrella Insurance',
    to: '/products/umbrellainsurance',
    type: 'router',
    iconName: 'mdi:umbrella'
  },
  {
    label: 'Home Warranty',
    to: 'https://fnrh.rateconnex.com/direct/vehicle/type',
    type: 'external',
    iconName: 'mdi:shield-home'
  },
  {
    label: 'Auto Warranty',
    to: 'https://fnra.rateconnex.com/direct/vehicle/type',
    type: 'external',
    iconName: 'mdi:car-cog'
  }
];

const memberCompanies = [
  {
    label: 'QuoteSlash',
    to: 'https://quoteslash.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Rocket Flood',
    to: 'https://rocketflood.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Rocket MGA',
    to: 'https://rocketmga.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'TheLeadExchange',
    to: 'http://www.theleadexchange.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Str8line Group',
    to: 'http://www.str8linegroup.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Str8line Enterprises',
    to: 'http://www.str8linegroup.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Protego VIP',
    to: 'https://protegovip.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'NuBuild',
    to: 'https://nubuildinsurance.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'The IE Pipeline',
    to: 'https://theiepipeline.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Graham Newton & McMahon Inc.',
    to: 'https://gnminsurance.com/',
    type: 'external',
    iconName: null
  },
  {
    label: 'Noble Care',
    to: 'https://www.noblecareinsurance.com/',
    type: 'external',
    iconName: null
  }
];

/**
 * Main menu items for desktop view
 * This can be directly used by PrimeVue Menubar component
 */
export const mainMenuItems = [
  {
    label: 'Home Page',
    iconName: 'mdi:home',
    to: '/',
    type: 'router'
  },
  {
    label: 'Insurance Products',
    iconName: 'mdi:shield-home',
    items: insuranceProducts
  },
  {
    label: 'Member Companies',
    iconName: 'mdi:office-building-outline',
    items: memberCompanies
  },
  {
    label: 'About Us',
    iconName: 'mdi:information',
    to: '/aboutus',
    type: 'router'
  },
  {
    label: 'Customer Service',
    iconName: 'mdi:account-supervisor-circle',
    to: '/customerservice',
    type: 'router'
  }
];

/**
 * Footer navigation items
 */
export const footerLinks = {
  products: insuranceProducts,
  resources: [
    {
      label: 'Customer Service',
      to: '/customerservice',
      type: 'router'
    },
    {
      label: 'Make a Claim',
      to: '/customerservice/carrier-directory/claims',
      type: 'router'
    },
    {
      label: 'Make a Payment',
      to: '/customerservice/carrier-directory/payments',
      type: 'router'
    },
    {
      label: 'Policy Search',
      to: '/policy-search',
      type: 'router'
    }
  ],
  company: [
    {
      label: 'About Us',
      to: '/aboutus',
      type: 'router'
    },
    {
      label: 'Member Companies',
      to: '#', // This is a dropdown, not a direct link
      type: 'router'
    },
    {
      label: 'Contact Us',
      to: '/contactus',
      type: 'router'
    },
    {
      label: 'Careers',
      to: '/careers',
      type: 'router'
    }
  ],
  legal: [
    {
      label: 'Privacy Policy',
      to: '/privacy-policy',
      type: 'router'
    },
    {
      label: 'Terms of Service',
      to: '/terms-of-service',
      type: 'router'
    }
  ]
};

/**
 * Contact information
 */
export const contactInfo = {
  phone: '800-268-9137',
  email: 'customerservice@insuranceexpress.com',
  address: '123 Insurance Way, Miami, FL 33101',
  mapLink: 'https://maps.app.goo.gl/H4kRn8Fph1rXRLWb9?g_st=ic'
};

export default {
  mainMenuItems,
  footerLinks,
  contactInfo,
  insuranceProducts,
  memberCompanies
}; 